<template>
    <a class="underline uppercase primary-color font-bold text-lg underline-offset-8 hover:brightness-75">
        <slot></slot>
    </a>
</template>
<script setup>
</script>
